import { sendModalMsg } from '@srm/ui/lib/modalMessages';
import type { INotifications } from '@models/Forms/IForms';

export interface ISaveNotificationsHandlers {
    /** Сохранить документ */
    save: () => void;
    /** Вернуться к правке: окно закрыто, документ не сохранён */
    stay?: () => void;
    /** Отменить карточку — как кнопка «Отменить»/«Закрыть». Без неё отказ — `stay`. */
    cancel?: () => void;
}

/**
 * Окно `<notifications>` формы перед сохранением. Без `confirm` — сообщение с «Продолжить» (сохранить); с `confirm` —
 * вопрос: `confirmText` сохраняет, `declineText` — отказ по `decline` (`cancel` — отменить карточку, по умолчанию;
 * `stay` — вернуться к правке). Крестик и Escape — всегда вернуться к правке: закрыть окно не значит сохранить.
 * Ответ один: повторное нажатие (двойной клик до снятия окна) ничего не делает.
 */
export const showSaveNotifications = (
    settings: INotifications | undefined,
    messages: string[],
    handlers: ISaveNotificationsHandlers,
) => {
    let answered = false;
    const once = (action?: () => void) => () => {
        if (answered) return;
        answered = true;
        action?.();
    };
    const save = once(handlers.save);
    const stay = once(handlers.stay);
    const cancel = settings?.decline !== 'stay' && handlers.cancel ? once(handlers.cancel) : undefined;
    sendModalMsg({
        title: settings?.title,
        message: messages,
        type: 'warning',
        dismissClick: stay,
        ...(settings?.confirm
            ? {
                  buttons: [{ title: settings.confirmText || 'Сохранить', onClick: save }],
                  closeBtnTitle: settings.declineText || (cancel ? 'Отменить' : 'Вернуться к правке'),
                  closeBtnClick: cancel ?? stay,
              }
            : { closeBtnTitle: 'Продолжить', closeBtnClick: save }),
    });
};
